import React, { FC, ReactNode } from 'react'

export interface IInlineLabelProps {
  children: ReactNode
}

export const InlineLabel: FC<IInlineLabelProps> = ({ children }) => {
  return <span className="text-silver-darker">{children}</span>
}
